import { ReactComponent as Spinner } from "assets/images/spinner-s.svg"
import { soul } from "lib/soul"
import { useEffect } from "react"
import { setAmplitudeUserId } from "../../lib/amplitude"

type StripeSuccessHandlerProps = {
  goNext: () => void
}

export function StripeSuccessHandler(props: StripeSuccessHandlerProps) {
  useEffect(() => {
    const fallbackUrl = new URL(location.href)
    fallbackUrl.searchParams.delete("stripe_success")
    fallbackUrl.searchParams.delete("session_id")
    const checkSessionStatus = async () => {
      try {
        const params = new URL(location.href).searchParams
        const { session_status } = await soul.purchases.getStripeSessionStatus(
          params.get("session_id"),
        )
        if (session_status === "complete") {
          const userId = localStorage.getItem("funnel_user_id")
          if (userId) {
            setAmplitudeUserId(userId)
          }
          props.goNext()
        } else {
          location.assign(fallbackUrl.href)
        }
      } catch {
        location.assign(fallbackUrl.href)
      }
    }

    checkSessionStatus()
  }, [])
  return (
    <div className="flex flex-col justify-center items-center h-full">
      <Spinner className="animate-spin text-white" />
    </div>
  )
}
